export const categoryColors = [
  { value: '#ffccc7', label: 'Red' },
  { value: '#ffd8bf', label: 'Volcano' },
  { value: '#ffe7ba', label: 'Orange' },
  { value: '#fff1b8', label: 'Gold' },
  { value: '#ffffb8', label: 'Yellow' },
  { value: '#f4ffb8', label: 'Lime' },
  { value: '#d9f7be', label: 'Green' },
  { value: '#b5f5ec', label: 'Cyan' },
  { value: '#bae0ff', label: 'Blue' },
  { value: '#d6e4ff', label: 'GeekBlue' },
  { value: '#efdbff', label: 'Purple' },
  { value: '#ffd6e7', label: 'Magenta' },
]
